import { AfterViewInit, Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { navCode } from 'src/app/shared/constants/channel.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AgencyModel, CityModel } from 'src/app/shared/models/abre-cuentas.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { RequestService } from '../../services/request/request-onboarding.service';

@Component({
  selector: 'app-offices-search',
  templateUrl: './offices-search.component.html',
  styleUrls: ['./offices-search.component.scss'],
})
export class OfficesSearchComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() isDisbursementOffice: boolean;
  @Output() officeSelectEventEmiter: EventEmitter<any> = new EventEmitter();
  @Output() nextDisbursementOffice: EventEmitter<void> = new EventEmitter();

  /**
   * Variable para agrupar el formulario
   *
   * *Form gruop variable*
   */
  formGroup: FormGroup;

  /**
   * Opciones para seleccionar la ciudad
   *
   * *Options to select the city*
   */
  options: any[];

  /**
   * Ciudad seleccionada por el usuario
   *
   * *User's city selection*
   */
  optionsFilter: any[];

  /**
   * Oficinas de la ciudad
   *
   * *City offices*
   */
  offices: any = [];

  /**
   * Tiene creditos cargados
   *
   * *hasSavedLoan*
   */
  hasSavedLoan: boolean;
  /**
   * Ciudad seleccionada por el usuario
   *
   * *User's city selection*
   */
  selectedCity: CityModel;

  /**
   * Ciudad anterior seleccionada por el usuario
   *
   * *User's city previous selection*
   */
  selectedPreviousCity: CityModel;

  /**
   * Estado para mostrar el aviso de error
   *
   * *State to show error advice*
   */
  showEmptyOfficeError = false;

  /**
   * Lista de las oficinas
   *
   * *Agency list*
   */
  optionsData: any = [];

  /**
   * Información de contacto del usuario
   *
   * *User's contact info*
   */
  contactInfo: ContactModel;

  /**
   * Existencia de las oficinas por ciudad
   *
   * *offices by city validation*
   */
  existOfficeByCity = false;

  existsOfficePreviousCity = false;

  /**
   * Cuerpo para envío de datos de taggeo
   *
   * *Body to send data by tag service*
   */
  eventCategories: any;

  /**
   * Oficinas filtradas
   *
   * *Filtered offices*
   */
  optionsOffice: any = [];

  /**
   * Oficinas filtradas
   *
   * *Filtered offices*
   */
  optionsOffice2: any = [];

  /**
   * Oficinas filtradas de la ciudad seleccionada anteriormente
   *
   * *Filtered offices of the city previously selected*
   */
  optionsOfficePreviousCity: any = [];

  /**
   * Validacion para mostrar la oficinas
   *
   * *Validation to show offices list*
   */
  showOptionsOffice = true;

  /**
   * Oficina seleccionada
   *
   * *Selected office*
   */
  selectedOffice: AgencyModel = {} as AgencyModel;
  /**
   * Variable para validar el titulo de acuerdo a la selección de desembolso
   *
   * *Pantalla reusada*
   */
  @Input() titleOffice: any;

  @Input() subTitle = true;

  back = '';
  /**
   * Error
   *
   * *error*
   */
  reactiveErrorOffice: string;
  district_option: any;
  selected_district: any;
  city_option: any;

  /**
   * Summary Initialize Services
   * @param abreCuentasService
   * @param parametersService
   * @param abreCuentasNavigationService
   * @param formBuilder
   */
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private formBuilder: FormBuilder,
    private taggingService: TaggingService,
    private biocatchService: BioCatchService,
    private requestService: RequestService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.eventCategories = {
      warning: {
        module: 'body',
        type: 'warning',
        position: 'bottom',
      },
      TextField: {
        module: 'body',
        type: 'textField',
        position: 'center',
      },
    };
    this.district_option = this.abreCuentasService.getDistricts();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isDisbursementOffice && !changes.isDisbursementOffice.currentValue) {
      if (this.abreCuentasService.getAgencySelected() !== undefined) {
        this.selectedOffice = this.abreCuentasService.getAgencySelected();
      }
    }
    if (changes.isDisbursementOffice && changes.isDisbursementOffice.currentValue) {
      if (this.abreCuentasService.getDisbursementAgencySelected() !== undefined) {
        this.selectedOffice = this.abreCuentasService.getDisbursementAgencySelected();
      }
    }
  }

  /**
   * Summary initial event, customer information
   */
  ngOnInit(): void {
    this.validateWithPurchase();
    this.previous();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.biocatchService.changeContext(StepBiocatchEnum.configuracion, product, false, true);
    this.contactInfo = this.abreCuentasService.getContactInfo();
    // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    this.optionsData = this.parametersService.getSetting(OpEnum.AGENCY_LIST);
    this.reactiveErrorOffice = this.copyService.copies.city_offices_search_city_filter_office_not_found_message;
    // this.optionsFilter = this.options.map(option => ({ data: option, value: option.description }));

    this.showOptionsOffice = true;
    this.selectedCity = {
      city_code: '',
      country_code: '',
      province_code: 0,
      description: '',
    };
    if (this.abreCuentasService.getCitySearchSelected().description !== undefined) {
      this.selectedCity = this.abreCuentasService.getCitySearchSelected();
      this.selected_district = this.selectedCity.district_id;
      this.abreCuentasService.setCitySearchSelected(this.selectedCity);
      this.loadOffices();
      return;
    }
    if (this.abreCuentasService.getContactInfo().address !== undefined) {
      this.selectedCity = this.contactInfo.address.city;
      this.selected_district = this.selectedCity.district_id;
      this.abreCuentasService.setCitySearchSelected(this.selectedCity);
      this.loadOffices();
      return;
    }
    if (this.abreCuentasService.getCitySearchSelected().description !== null) {
      this.selectedCity = this.abreCuentasService.getCitySearchSelected();
      this.selected_district = this.selectedCity.district_id;
    }
  }

  /**
   * Summary Call after angular has fully started the component view, initialization of the form
   */
  ngAfterViewInit() {
    this.formGroup = new FormGroup({
      'input-value-city': new FormControl('', [Validators.required]),
    });

    if (this.selectedCity.description === null && !this.showOptionsOffice && this.optionsOffice.length <= 0) {
      return;
    }

    this.formGroup = new FormGroup({
      'input-value-office': new FormControl('', [Validators.required]),
    });
  }

  /**
   * Load list of offices depending on a filter of the city,
   * optionOfficePrevious city and existsOfficePreviousCity validates if there are
   * offices in the city that was previously selected and it is used to validate if the
   * warning advice wil be shown
   *
   */
  loadOffices() {
    this.optionsOffice = this.optionsData.filter(optionOffice => (optionOffice.city_code === this.selectedCity.city_code
      && optionOffice.province_code.toString() === this.selectedCity.province_code.toString()));
    this.optionsOffice2 = this.optionsOffice;
    this.existOfficeByCity = this.optionsOffice2.length > 0;

    if (!this.existOfficeByCity) {
      const error = this.navigationService.camelize(this.reactiveErrorOffice);
      this.pageTagEvent('3', this.eventCategories.warning, 'show', error);
    }

    if (this.selectedPreviousCity === undefined) {
      return;
    }

    this.optionsOfficePreviousCity = this.optionsData.filter(optionOffice => (optionOffice.city_code === this.selectedPreviousCity.city_code
      && optionOffice.province_code === this.selectedPreviousCity.province_code));
    this.existsOfficePreviousCity = this.optionsOfficePreviousCity.length > 0;

    if (!this.existsOfficePreviousCity) {
      this.showEmptyOfficeError = true;
    }
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event: any) {
    if (event.value) {
      this.selectedPreviousCity = event.value;
      this.showEmptyOfficeError = false;
      this.selectedCity = this.options.find(e => e.city_code === event.value.city_code &&
        e.province_code === event.value.province_code);
      this.abreCuentasService.setCitySearchSelected(this.selectedCity);
      this.loadOffices();
    } else {
      this.showOptionsOffice = true;
      this.selectedCity = {
        city_code: '0',
        province_code: 5,
        description: '',
        country_code: '',
      };
      this.loadOffices();
    }
  }
  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOptionOffice(event: any) {
    if (event.value) {
      this.selectedOffice = event.value;
      this.pageTagEvent('4', this.eventCategories.TextField, 'click', event.description);
      this.officeSelectEventEmiter.emit(event.value);
      if (this.selectedCity.province_code > 0 && this.selectedOffice.province_code > 0) {
        this.showOptionsOffice = false;
      }
    } else {
      this.showOptionsOffice = true;
      this.selectedOffice = {
        address: '',
        agency_code: '',
        city_code: '',
        country_code: '',
        description: '',
        province_code: 0,
      };
    }
  }

  validateWithPurchase() {
    this.hasSavedLoan = (
      this.abreCuentasService.haveLoan &&
      this.abreCuentasService.getRequestLoanSelected().elementId === '02' &&
      this.abreCuentasService.getRequestEntity() !== 1 &&
      (!this.abreCuentasService.getFormLoan() || this.abreCuentasService.getDidBackAddLoan())
    );
  }

  regularNavigation() {
    if (this.abreCuentasService.haveLoan && this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationMultiLoan();
    } else if (this.abreCuentasService.getOfficeStatus()) {
      this.nextDisbursementOffice.emit();
    } else if (this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep();
    }
  }
  navigationMultiLoan() {
    this.abreCuentasService.getPostlogin() ? this.abreCuentasService.setPassScreenCity(navCode[3]) : this.abreCuentasService.setPassScreenCity(navCode[1]);
    this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
  }

  /**
   * Summary next event validation
   */
  next() {
    if (this.abreCuentasService.haveLoan) {
      this.flowLoan();
    } else {
      this.regularNavigation();
    }
  }

  flowLoan() {
    if (this.abreCuentasService.viewOptionMultiProduct && this.abreCuentasService.getPassScreenCity() === navCode[1]) {
      this.abreCuentasService.setPassScreenCity(navCode[2]);
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else if (this.hasSavedLoan) {
      this.navigationService.nextStep(navCode[206]);
      this.abreCuentasService.getPostlogin() ? this.abreCuentasService.setPassScreenCity(navCode[0]) : this.abreCuentasService.setPassScreenCity(navCode[1]);
    } else {
      this.regularNavigation();
    }
  }

  /**
   * @author cramos
   * @param eventNumber id number of event 1/2/3/4
   * @param category object with properties see eventCategories variable
   * @param customAction action of event click/show
   * @param message  message of event click
   */
  pageTagEvent(eventNumber: string, category: any, customAction: string, error?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
        {
          path:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction[customAction],
        label: EVENT[`${tagPageName}E${eventNumber}customLabel`],
        errorName: error,
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  regularPrevious() {
    this.back = navCode[200];
    if (this.abreCuentasService.getOutlaySelection()) {
      switch (this.abreCuentasService.getOutlaySelection()) {
        case BUSINESS_CONST.ITAU:
          this.back = navCode[202];
          break;
        case BUSINESS_CONST.CHEQUE_ITAU:
          if (this.abreCuentasService.getReceiveCard() === '1') {
            this.back = navCode[202];
          } else {
            this.back = navCode[201];
          }
          break;
        default:
          this.back = navCode[201];
          break;
      }
    }
  }

  /**
   * metodo para volver
   */
  previous() {
    if (
      this.abreCuentasService.getFormLoan() &&
      !this.abreCuentasService.getDidBackAddLoan()
    ) {
      this.back = navCode[201];
    } else {
      this.regularPrevious();
    }
  }

  async getCitys(provence_id: string) {
    await this.requestService.cityBranches(provence_id).then(response => {
      this.city_option = response.body;
      let cityReturn = this.city_option.map(data => {
        const codeDane = data.code_dane;
        const codeDanelength = codeDane.length - 3;
        return {
          city_code: codeDane.substring(codeDanelength),
          province_code: +codeDane.substring(0, codeDanelength),
          description: data.city,
          district_id: data.district.district_id,
        };
      },
        );
      this.options = cityReturn.filter(x => this.optionsData.map(y => y.city_code + y.province_code.toString()).includes(x.city_code + x.province_code.toString()));
      if (this.options.length === 0) {
        this.city_option = undefined;
        this.showEmptyOfficeError = true;
      }
    });
  }

  selectOptionProvidence(event) {
    const value: string = event.value;
    console.log(event);
    if (value && value.trim() !== '') {
      this.selected_district = value;
      this.getCitys(value);
    } else {
      this.showOptionsOffice = true;
      this.city_option = undefined;
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
      this.selected_district = undefined;
      this.loadOffices();
      this.showEmptyOfficeError = false;
      this.existOfficeByCity = true;
    }
  }
}
